import {get, post,postForm} from "@/http/ys"

const baseUrl = "voice/";

export default {
    upload: (params) => {
        return post(baseUrl + 'upload', params)
    },
    sendonce: ({voiceFile, ...data}) => {
        return postForm( baseUrl + 'sendonce?',data, {voiceFile})
    },


}